<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar :title="title">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="apply-body">
      <van-skeleton :row="3" :loading="loading" :style="{ paddingTop: '16px' }">
        <van-form @submit="handleSubmit"  ref="jobUploadForm" scroll-to-error>
          <van-cell-group inset class="submit-form">
            <van-field v-model.trim="jobInfo['title']" name="title" label="职位名称" placeholder="请输入"
                       clearable :readonly="isOverdue === true"
                       :disabled="isAdd === false && isOverdue === false"
                       :rules="[{ required: true, message: '职位名称不能为空' }]" :required="isAdd === true" />

            <van-field v-model="jobInfo['company']" name="company" label="公司" placeholder="请选择"
                       :is-link="isAdd === true" :readonly="isOverdue === true"
                       :disabled="isAdd === false && isOverdue === false"
                       @click="showCompanyPopup"
                       :rules="[{ required: true, message: '公司不能为空' }]" :required="isAdd === true" />
            <van-popup v-model:show="isShowCompany" round position="bottom">
              <van-picker title="选择公司" :columns="companyOption" @cancel="isShowCompany = false" @confirm="setCompany"/>
            </van-popup>

            <van-field v-model="jobInfo['city']" name="city" label="城市" placeholder="请选择"
                       :is-link="cityAble === true" :readonly="isOverdue === true"
                       :disabled="cityAble === false && isOverdue === false"
                       @click="showCityPopup"
                       :rules="[{ required: true, message: '城市不能为空' }]" :required="cityAble === true" />
            <van-field v-model="jobInfo['address']" name="address" label="地址"
                       type="textarea" autosize
                       :readonly="isOverdue === true" :disabled="isOverdue === false" />
            <van-popup v-model:show="isShowCity" round position="bottom">
              <van-picker title="选择城市" :columns="cityOption" @cancel="isShowCity = false" @confirm="setCity"/>
            </van-popup>

            <van-field v-model="isSchool" name="company" label="是否校招" placeholder="请选择"
                       :is-link="isOverdue === false" :readonly="isOverdue === true"
                       @click="showYNPopup"
                       :rules="[{ required: true, message: '是否校招不能为空' }]" :required="isOverdue === false" />
            <van-popup v-model:show="isShowYN" round position="bottom">
              <van-picker title="是否校招" :columns="ynOption" @cancel="isShowYN = false" @confirm="setYN"/>
            </van-popup>

            <van-field v-model="jobInfo['type']" name="type" label="职位类型" placeholder="请选择"
                       :is-link="isOverdue === false" :readonly="isOverdue === true"
                       @click="showTypePopup"
                       :rules="[{ required: true, message: '职位类型不能为空' }]" :required="isOverdue === false" />
            <van-popup v-model:show="isShowType" round position="bottom">
              <van-nav-bar title="选择职位类型"
                           right-text="确认" @click-right="isShowType = false">
                <template #left>
                  <van-checkbox v-model="isCheckAllType" :indeterminate="isIndeterminateType" @change="checkAllChangeType">
                    全选
                  </van-checkbox>
                </template>
              </van-nav-bar>
              <van-checkbox-group v-model="checkedResultType" @change="checkedResultChangeType">
                <van-cell-group inset>
                  <van-cell v-for="item in typeOption" :key="item['value']" :title="item['text']">
                    <template #right-icon>
                      <van-checkbox :name="item['text']"/>
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </van-popup>

            <van-field v-model.trim="jobInfo['number']" name="number" label="招聘人数" placeholder="请输入"
                       type="digit" clearable
                       :readonly="isOverdue === true"
                       :rules="[{ required: true, message: '招聘人数不能为空' }]" :required="isOverdue === false" />

            <van-field v-model.trim="jobInfo['description']" name="description" label="职位描述" placeholder="请输入"
                       type="textarea" autosize clearable
                       :readonly="isOverdue === true"
                       :rules="[{ required: true, message: '职位描述不能为空' }]" :required="isOverdue === false" />

            <van-field v-model.trim="jobInfo['education']" name="education" label="学历要求" placeholder="请输入"
                       type="text" clearable
                       :readonly="isOverdue === true"
                       :rules="[{ required: true, message: '学历要求不能为空' }]" :required="isOverdue === false" />

            <van-field v-model.trim="jobInfo['major']" name="major" label="专业要求" placeholder="请输入"
                       type="text" clearable
                       :readonly="isOverdue === true"
                       :rules="[{ required: true, message: '专业要求不能为空' }]" :required="isOverdue === false" />

            <van-field v-model.trim="jobInfo['requirement']" name="requirement" label="任职要求" placeholder="请输入"
                       type="textarea" autosize clearable
                       :readonly="isOverdue === true"
                       :rules="[{ required: true, message: '任职要求不能为空' }]" :required="isOverdue === false" />

            <van-field v-model="jobInfo['benefit']" name="benefit" label="福利待遇" placeholder="请选择"
                       type="textarea" autosize
                       :is-link="isOverdue === false" :readonly="isOverdue === true"
                       @click="showBenefitPopup"
                       :rules="[{ required: true, message: '福利待遇不能为空' }]" :required="isOverdue === false" />
            <van-popup v-model:show="isShowBenefit" round position="bottom">
              <van-nav-bar title="选择福利待遇"
                           right-text="确认" @click-right="isShowBenefit = false">
                <template #left>
                  <van-checkbox v-model="isCheckAll" :indeterminate="isIndeterminate" @change="checkAllChange">
                    全选
                  </van-checkbox>
                </template>
              </van-nav-bar>
              <van-checkbox-group v-model="checkedResult" @change="checkedResultChange">
                <van-cell-group inset>
                  <van-cell v-for="item in benefitOption" :key="item['value']" :title="item['text']">
                    <template #right-icon>
                      <van-checkbox :name="item['text']"/>
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </van-popup>

            <van-field v-model="duration" name="duration" label="招聘期限" placeholder="请选择"
                       :is-link="isOverdue === false" :readonly="isOverdue === true"
                       @click="showDurationPopup"
                       :rules="[{ required: true, message: '招聘期限不能为空' }]" :required="isOverdue === false" />
            <van-calendar v-model:show="isShowDuration" type="range" @confirm="setDuration" />

          </van-cell-group>

          <div class="button">
            <van-button class="submit-button" type="primary" round block native-type="submit" v-show="isOverdue === false">保存</van-button>
          </div>
        </van-form>
      </van-skeleton>
    </div>


  </div>
</template>

<script>
import {addJob, getAllTypeOption, getBenefitOption, getCityOptionForCompany, getCompanyOption} from "@/api";
import {parseTime, selectDictText, selectDictValue} from "@/api/common";
import {showConfirmDialog, showDialog, showNotify} from "vant";

export default {
  name: "JobForm",
  data() {
    return {
      loading: true,
      title: '新增职位',
      isAdd: false,
      isOverdue: false,
      userInfo: {},
      jobInfo: {},
      jobId: '',

      isShowCompany: false,
      companyOption: [],

      cityAble: false,
      isShowCity: false,
      cityOption: [],

      isSchool: undefined,
      isShowYN: false,
      ynOption: [
        { text: '是', value: 1 },
        { text: '否', value: 0 },
      ],

      isShowType: false,
      typeOption: [],
      isCheckAllType: false,
      isIndeterminateType: false,
      checkedResultType: [],

      isShowBenefit: false,
      benefitOption: [],
      isCheckAll: false,
      isIndeterminate: false,
      checkedResult: [],

      duration: '',
      isShowDuration: false,

      form: undefined,

    }
  },
  mounted() {
    this.loading = true;

    getAllTypeOption().then((res) => {
      if (res.code === 200) {
        this.typeOption = res.data;
      }
    });

    getBenefitOption().then((res) => {
      if (res.code === 200) {
        this.benefitOption = res.data;
      }
    });

    this.jobInfo = JSON.parse(window.sessionStorage.getItem('jobInfo'));
    this.jobId = this.$route.params['jobId'];
    if (this.jobId !== '0') {
      this.jobInfo = JSON.parse(window.sessionStorage.getItem('jobInfo'));
      this.isSchool = selectDictText(this.ynOption, this.jobInfo['isSchool']);
      this.checkedResultType = this.jobInfo['type'].split('、');
      this.checkedResult = this.jobInfo['benefit'].split('、');
      this.duration = parseTime(this.jobInfo['startAt'].split(' ')[0], '{y}/{m}/{d}')
          + ' - '
          + parseTime(this.jobInfo['endAt'].split(' ')[0], '{y}/{m}/{d}')
      this.isAdd = false;
      if (this.jobInfo['state'] === '-1') {
        this.isOverdue = true;
        this.title = '过期职位';
      } else {
        this.isOverdue = false;
        this.title = '修改职位';
      }
      this.loading = false;
    } else {
      this.jobInfo = {};
      this.title = '新增职位';
      this.isAdd = true;
      getCompanyOption().then((res) => {
        if (res.code === 200) {
          this.companyOption = res.data;
        }
      });
      this.loading = false;
    }
  },
  methods: {
    goBack() {
      window.history.back();
    },
    showCompanyPopup() {
      if (this.isAdd === true) {
        this.isShowCompany = true;
      }
    },
    setCompany(option) {
      let values = option.selectedValues;
      this.jobInfo['companyId'] = values[0];
      this.jobInfo['company'] = selectDictText(this.companyOption, values[0]);
      this.isShowCompany = false;

      getCityOptionForCompany('companyId=' + values[0]).then((res) => {
        if (res.code === 200) {
          this.cityOption = res.data;
          this.jobInfo['cityId'] = this.cityOption[0]['value'];
          let city = this.cityOption[0]['text'].split(' · ');
          this.jobInfo['city'] = city[0];
          this.jobInfo['address'] = city[1];
          this.cityAble = true;
        }
      });
    },
    showCityPopup() {
      if (this.cityAble === true) {
        this.isShowCity = true;
      }
    },
    setCity(option) {
      let values = option.selectedValues;
      this.jobInfo['cityId'] = values[0];
      let city = selectDictText(this.cityOption, values[0]).split(' · ');
      this.jobInfo['city'] = city[0];
      this.jobInfo['address'] = city[1];
      this.isShowCity = false;
    },
    showYNPopup() {
      if (this.isOverdue === false) {
        this.isShowYN = true;
      }
    },
    setYN(option) {
      let values = option.selectedValues;
      this.jobInfo['isSchool'] = values[0];
      this.isSchool = selectDictText(this.ynOption, values[0]);
      this.isShowYN = false;
    },
    showTypePopup() {
      if (this.isOverdue === false) {
        this.isShowType = true;
      }
    },
    checkAllChangeType(isAll) {
      this.checkedResultType = [];
      this.jobInfo['type'] = '';
      this.jobInfo['typeId'] = '';
      if (isAll === true) {
        for (let item of this.typeOption) {
          this.checkedResultType.push(item['text']);
          this.jobInfo['type'] += item['text'] + '、';
          this.jobInfo['typeId'] += item['value'] + ',';
        }
        this.jobInfo['type'] = this.jobInfo['type'].substring(0, this.jobInfo['type'].length - 1);
        this.jobInfo['typeId'] = this.jobInfo['typeId'].substring(0, this.jobInfo['typeId'].length - 1);
      }
    },
    checkedResultChangeType(option) {
      this.checkedResultType = option;
      this.isIndeterminateType = option.length > 0 && option.length < this.typeOption.length;

      let optionSorted = {};
      for (let item of option) {
        optionSorted[selectDictValue(this.typeOption, item)] = item;
      }
      this.jobInfo['type'] = '';
      this.jobInfo['typeId'] = '';
      for (let key in optionSorted) {
        this.jobInfo['type'] += optionSorted[key] + '、';
        this.jobInfo['typeId'] += key + ',';
      }
      this.jobInfo['type'] = this.jobInfo['type'].substring(0, this.jobInfo['type'].length - 1);
      this.jobInfo['typeId'] = this.jobInfo['typeId'].substring(0, this.jobInfo['typeId'].length - 1);
    },
    showBenefitPopup() {
      if (this.isOverdue === false) {
        this.isShowBenefit = true;
      }
    },
    checkAllChange(isAll) {
      this.checkedResult = [];
      this.jobInfo['benefit'] = '';
      this.jobInfo['benefitId'] = '';
      if (isAll === true) {
        for (let item of this.benefitOption) {
          this.checkedResult.push(item['text']);
          this.jobInfo['benefit'] += item['text'] + '、';
          this.jobInfo['benefitId'] += item['value'] + ',';
        }
        this.jobInfo['benefit'] = this.jobInfo['benefit'].substring(0, this.jobInfo['benefit'].length - 1);
        this.jobInfo['benefitId'] = this.jobInfo['benefitId'].substring(0, this.jobInfo['benefitId'].length - 1);
      }
    },
    checkedResultChange(option) {
      this.checkedResult = option;
      this.isIndeterminate = option.length > 0 && option.length < this.benefitOption.length;

      let optionSorted = {};
      for (let item of option) {
        optionSorted[selectDictValue(this.benefitOption, item)] = item;
      }
      this.jobInfo['benefit'] = '';
      this.jobInfo['benefitId'] = '';
      for (let key in optionSorted) {
        this.jobInfo['benefit'] += optionSorted[key] + '、';
        this.jobInfo['benefitId'] += key + ',';
      }
      this.jobInfo['benefit'] = this.jobInfo['benefit'].substring(0, this.jobInfo['benefit'].length - 1);
      this.jobInfo['benefitId'] = this.jobInfo['benefitId'].substring(0, this.jobInfo['benefitId'].length - 1);
    },
    showDurationPopup() {
      if (this.isOverdue === false) {
        this.isShowDuration = true;
      }
    },
    setDuration(dates) {
      this.jobInfo['startAt'] = parseTime(dates[0], '{y}-{m}-{d}') + ' 00:00:00';
      this.jobInfo['endAt'] = parseTime(dates[1], '{y}-{m}-{d}') + ' 23:59:59';
      this.duration = parseTime(dates[0], '{y}/{m}/{d}') + ' - ' + parseTime(dates[1], '{y}/{m}/{d}')
      this.isShowDuration = false;
    },
    handleSubmit() {
      this.form = new FormData();
      let keys = Object.keys(this.jobInfo);
      let flag = 0;

      if (this.isAdd === false) {
        let jobInfo = JSON.parse(window.sessionStorage.getItem('jobInfo'));
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i];
          if (key === 'number') {
            if (Number(this.jobInfo[key]) === Number(jobInfo[key])) {
              flag++;
            }
          } else {
            if (this.jobInfo[key] === jobInfo[key]) {
              flag++;
            }
          }
        }
      }

      if (flag === keys.length) {
        showDialog({
          message: '未进行任何修改。',
        }).then(() => {
        });
      } else {
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i];
          if (key === 'createdAt' || key === 'updatedAt') {
            continue;
          }
          this.form.append(key, this.jobInfo[key]);
        }

        showConfirmDialog({
          message: '是否确认保存？',
        }).then(() => {
          addJob(this.form).then((res) => {
            if (res.code === 200) {
              showNotify({ type: 'success', message: res.msg, position: 'bottom' });
              this.goBack();
            } else {
              showNotify({ type: 'danger', message: res.msg, position: 'bottom' });
            }
          });
        }).catch(() => {
          // on cancel
        });

      }

    },
  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
  background-color: rgb(248,248,248);
  padding-bottom: 10px;
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding-bottom: 20px;
}

.submit-form {
  margin: 0;
}

.button {
  padding: 0 16px 20px;
}

.submit-button {
  font-size: 18px;
  margin-top: 20px;
}
</style>